import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import DataTag from '../../../../components/Display/DataTag';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import { getConstant } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import DocumentItem from '../../common/document/DocumentItem';

function HighlightDetail({
  highlight,
  handleUpdateHighlight,
  handleDelete,
  handleCreateFile,
  handleUpdateFile,
  handleDeleteFile
}) {
  const updateHighlightActions = [
    {
      onClick: handleUpdateHighlight,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (highlight) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce temps fort / Alumni ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      acceptClassName: 'bg-red-500 border-red-500',
      accept: () => handleDelete(highlight)
    });
  };

  const confirmDocumentDeletion = (document) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteFile(document)
    });
  };

  const newFileActions = [
    {
      onClick: handleCreateFile,
      label: 'Ajouter un fichier',
      icon: 'pi-plus'
    }
  ];

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateHighlightActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={highlight.title} large />

          <DataTag
            key="status"
            label={'Statut'}
            tag={{
              label: getConstant('shared.draftTypes', highlight.is_draft).label,
              bgColor: getConstant('shared.draftTypes', highlight.is_draft).bgColor
            }}
            large
          />
          <DataTag
            key="type"
            label={'Type'}
            tag={{
              label: getConstant('quatrebis.highlightType', highlight.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
            large
          />
        </div>
        <div className="flex flex-wrap gap-5">
          <MultiLineData key="resume" label={'Résumé'} value={highlight.resume} large asHtml />
        </div>

        <div className="flex flex-wrap gap-5">
          <MultiLineData
            key="description"
            label={'Description'}
            value={highlight.description}
            large
            asHtml
          />
        </div>
      </Section>
      <Section label="Image principale">
        <ImageItem image={highlight.image} className="w-96" />
      </Section>
      <Section label="Fichiers téléchargeables" actions={newFileActions}>
        {highlight.documents?.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {highlight.documents.map((file) => (
              <DocumentItem
                key={file.id}
                document={file}
                onUpdate={() => handleUpdateFile(file)}
                onDelete={() => confirmDocumentDeletion(file)}
              />
            ))}
          </div>
        ) : (
          <p className="italic text-slate-400 font-light">Non renseignés</p>
        )}
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={'Supprimer le temps fort / Alumni'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(highlight)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default HighlightDetail;
